'use client';

import { useCallback, useState } from 'react';
import Script from 'next/script';

import { Skeleton } from '@common/atoms/Skeleton';
import { EmbedConsentGuard } from '@web/atoms/EmbedConsentGuard';
import { useEmbedConsented } from '@web/hooks/useEmbedConsented';

import styles from './JobsOverviewWidget.module.scss';

declare global {
    interface Window {
        Homerun?: any;
    }
}

export const JobsOverviewWidget = () => {
    const [loadingScript, setLoadingScript] = useState(true);
    const { consented, loadingConsent } = useEmbedConsented('homerun');

    const loadWidget = useCallback(() => {
        window.Homerun?.loadWidget('hfohtvdrc9wxjc4bo0wg');
        setLoadingScript(false);
    }, []);

    return (
        <div className={styles['jobs-overview-widget']}>
            {loadingConsent || (consented && loadingScript) ? <Skeleton /> : null}

            {!consented && !loadingConsent ? <EmbedConsentGuard vendor="homerun" /> : null}

            {consented ? (
                <>
                    <div id="homerun-jobs-widget" data-testid="homerun-jobs-widget" />
                    <Script
                        strategy="lazyOnload"
                        src="https://d3s4clg74dg0wr.cloudfront.net/widget/js/main.js?v=7.0.0"
                        onLoad={loadWidget}
                    />
                </>
            ) : null}
        </div>
    );
};
